/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React from "react";
import PinCodeSettings from "../../../UserManagement/ProfileSettings/ProfileSettingsTabs/SecurityTab/PinCodeSettings/PinCodeSettings";
import { strings } from "../../../../common/Strings/Strings";
import Button from "../../../../components/Button";

interface Props {
  onSkip: () => void;
}

export const PinNumberCard: React.FC<Props> = ({ onSkip }: Props) => (
  <div className="tw-card-outside">
    <div className="tw-card-inside">
      <div>
        <h1 className="tw-card-h1">{strings.setPinNumber}</h1>
      </div>
      <PinCodeSettings asCard={false} canCancel={false} />
      <div className="grid grid-cols-2 gap-4">
        <div className="flex justify-start">
          <span className="text-left font-medium text-sm text-gray-500 dark:text-gray-400">{strings.setItLater}</span>
        </div>
        <div className="flex justify-end">
          <Button onClick={onSkip} variant="link" className="text-sm">
            {strings.skipForNow}
          </Button>
        </div>
      </div>
    </div>
  </div>
);
